import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardTitle,
  CardText,
  Grid,
  TextField,
  LinearProgress,
  Button,
  FontIcon,
  SelectField,
} from 'react-md';

import userService from './../../services/users';

import DefaultLayout from './../../components/layouts/default';

import './users.css';

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addUser: false,
      addUserLoading: false,
      systemUsers: null,
      systemUsersLoading: false,
      selectedRows: [],
      deletingSelected: false,
    };

    this.getSystemUsers = this.getSystemUsers.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteSystemUser = this.deleteSystemUser.bind(this);
    this.deleteSelectedUsers = this.deleteSelectedUsers.bind(this);
    this.handleRowToggle = this.handleRowToggle.bind(this);
    this.clearForm = this.clearForm.bind(this);
  }

  componentDidMount() {
    this.getSystemUsers();
  }

  getSystemUsers() {
    this.setState({systemUsersLoading: true});
    return userService.getSystemUsers()
      .then(response => {
        const currentRole = this.props.currentUser && this.props.currentUser.role;
        const filteredResponse = currentRole === 'root'
          ? response
          : response.filter(item => item.role === 'admin' || item.role === 'user');

        this.setState({
          systemUsersLoading: false,
          selectedRows: [],
          systemUsers: filteredResponse.map(item => ({
            id: item.id,
            Usuario: item.username,
            Nombre: item.first_name,
            Apellido: item.last_name,
            Email: item.email,
            Rol: item.role,
            Status: item.status,
          }))
        });
      })
      .catch(error => {
        this.setState({systemUsersLoading: false});
      });
  }

  handleChange(value, e) {
    const newState = {[e.target.name]: value};
    if (e.target.name === 'addSystemUserUsername') {
      newState.addSystemUserUsernameError = null;
    }
    this.setState(newState);
  }

  handleSelectChange(value, index, event, details) {
    this.setState({[details.name]: value});
  }

  validateUsername(username) {
    if (!username) return 'El nombre de usuario es obligatorio';
    if (username.length < 6) return 'Debe tener al menos 6 caracteres';
    if (!/^[a-zA-Z0-9]+$/.test(username)) return 'Solo letras y números, sin espacios ni caracteres especiales';
    return null;
  }

  handleSubmit(event) {
    event.preventDefault();
    const usernameError = this.validateUsername(this.state.addSystemUserUsername);
    if (usernameError) {
      this.setState({ addSystemUserUsernameError: usernameError });
      return;
    }
    this.setState({addUserLoading: true, addSystemUserUsernameError: null});
    return userService.addSystemUser({
      username: this.state.addSystemUserUsername,
      status: 'active',
      role: this.state.addSystemUserRole,
      first_name: this.state.addSystemUserFirstName,
      last_name: this.state.addSystemUserLastName,
      email: this.state.addSystemUserEmail,
      password: this.state.addSystemUserPassword
    })
      .then(() => {
        this.setState({
          addUserLoading: false,
          addUser: false
        });
        this.clearForm();
        this.getSystemUsers();
      })
      .catch(error => {
        console.log(error);
        this.setState({addUserLoading: false});
      });
  }

  deleteSystemUser(item) {
    if (window.confirm(`¿Eliminar al usuario '${item.Usuario}?'`)) {
      userService.removeSystemUser(item.id)
        .then((response) => {
          this.getSystemUsers();
        })
        .catch(error => console.log(error));
    }
  }

  deleteSelectedUsers() {
    const { selectedRows, systemUsers } = this.state;
    const usersToDelete = systemUsers.filter((_, index) => selectedRows[index]);
    const count = usersToDelete.length;

    if (count === 0) return;

    if (window.confirm(`¿Eliminar ${count} usuario${count > 1 ? 's' : ''} seleccionado${count > 1 ? 's' : ''}?`)) {
      this.setState({ deletingSelected: true });
      Promise.all(usersToDelete.map(user => userService.removeSystemUser(user.id)))
        .then(() => {
          this.setState({ selectedRows: [], deletingSelected: false });
          this.getSystemUsers();
        })
        .catch(error => {
          console.log(error);
          this.setState({ deletingSelected: false });
          this.getSystemUsers();
        });
    }
  }

  handleRowToggle(rowIndex, checked, count) {
    const { systemUsers } = this.state;
    let selectedRows = [...this.state.selectedRows];

    if (rowIndex === 0) {
      // Header checkbox: select/deselect all
      selectedRows = systemUsers.map(() => checked);
    } else {
      // Individual row (rowIndex is 1-based for body rows)
      selectedRows[rowIndex - 1] = checked;
    }

    this.setState({ selectedRows });
  }

  clearForm() {
    this.setState({
      addSystemUserUsername: null,
      addSystemUserRole: null,
      addSystemUserFirstName: null,
      addSystemUserLastName: null,
      addSystemUserEmail: null,
      addSystemUserPassword: null,
    });
  }

  render() {
    return (
      <DefaultLayout>
        {/* TODO: Botón y formulario de agregar usuario ocultos temporalmente.
            Motivo: problema con la creación de contraseña. Reactivar cuando se corrija. */}
        {/*
        <div className='buttons__group' style={{marginBottom: '2rem'}}>
          <Button onClick={() => this.setState({addUser: !this.state.addUser})} floating primary>
            <FontIcon>person_add</FontIcon>
          </Button>
        </div>
        {this.state.addUser && (
          <Card className="users-add-card">
            <CardTitle title='Agregar usuario' />
            <CardText>
              <form onSubmit={this.handleSubmit}>
                <Grid>
                  <TextField
                    id='addSystemUserUsername'
                    name='addSystemUserUsername'
                    label='Nombre de usuario'
                    lineDirection='center'
                    placeholder='Ingrese el nombre de usuario'
                    className='md-cell md-cell--bottom users-input-box'
                    value={this.state.addSystemUserUsername}
                    onChange={this.handleChange}
                    disabled={this.state.addUserLoading}
                    error={!!this.state.addSystemUserUsernameError}
                    errorText={this.state.addSystemUserUsernameError}
                    required
                  />
                  <TextField
                    id='addSystemUserFirstName'
                    name='addSystemUserFirstName'
                    label='Nombre'
                    lineDirection='center'
                    placeholder='Ingrese el nombre'
                    className='md-cell md-cell--bottom users-input-box'
                    value={this.state.addSystemUserFirstName}
                    onChange={this.handleChange}
                    disabled={this.state.addUserLoading}
                  />
                  <TextField
                    id='addSystemUserLastName'
                    name='addSystemUserLastName'
                    label='Apellido'
                    lineDirection='center'
                    placeholder='Ingrese el apellido'
                    className='md-cell md-cell--bottom users-input-box'
                    value={this.state.addSystemUserLastName}
                    onChange={this.handleChange}
                    disabled={this.state.addUserLoading}
                  />
                  <TextField
                    id='addSystemUserEmail'
                    name='addSystemUserEmail'
                    label='Email'
                    lineDirection='center'
                    placeholder='Ingrese la dirección de email'
                    className='md-cell md-cell--bottom users-input-box'
                    value={this.state.addSystemUserEmail}
                    onChange={this.handleChange}
                    disabled={this.state.addUserLoading}
                    required
                  />
                  <SelectField
                    id='addSystemUserRole'
                    name='addSystemUserRole'
                    label='Rol'
                    placeholder='Seleccione rol de usuario'
                    className='md-cell md-cell--bottom users-input-box'
                    menuItems={
                      this.props.currentUser && this.props.currentUser.role === 'root'
                        ? [
                            { label: 'Usuario', value: 'user' },
                            { label: 'Administrador', value: 'admin' },
                            { label: 'Root', value: 'root' },
                          ]
                        : [
                            { label: 'Usuario', value: 'user' },
                            { label: 'Administrador', value: 'admin' },
                          ]
                    }
                    value={this.state.addSystemUserRole}
                    onChange={this.handleSelectChange}
                    disabled={this.state.addUserLoading}
                  />
                  <div className='md-cell md-cell--bottom users-input-box users-password-wrapper'>
                    <TextField
                      id='addSystemUserPassword'
                      name='addSystemUserPassword'
                      label='Contraseña'
                      type='password'
                      passwordIcon={<FontIcon>remove_red_eye</FontIcon>}
                      value={this.state.addSystemUserPassword}
                      onChange={this.handleChange}
                      disabled={this.state.addUserLoading}
                      required
                    />
                    <span className="users-input-note">Mínimo 6 caracteres. Solo letras y números, sin espacios.</span>
                  </div>
                  <Button
                    type='submit'
                    disabled={this.state.addUserLoading}
                    flat
                    primary
                    swapTheming
                  >
                    Agregar usuario
                  </Button>
                </Grid>
              </form>
            </CardText>
          </Card>
        )}
        */}
        <div className="users-table-container">
          <div className="users-table-header">
            <div className="users-table-header__left">
              <FontIcon className="users-table-header__icon">people</FontIcon>
              <div>
                <h2 className="users-table-header__title">Usuarios del sistema</h2>
                <span className="users-table-header__subtitle">
                  {this.state.systemUsers ? `${this.state.systemUsers.length} usuarios registrados` : 'Cargando...'}
                </span>
              </div>
            </div>
            <div className="users-table-header__actions">
              {this.state.selectedRows.filter(Boolean).length > 0 && (
                <Button
                  className="users-table-delete-selected-btn"
                  onClick={this.deleteSelectedUsers}
                  flat
                  disabled={this.state.deletingSelected}
                >
                  <FontIcon>delete</FontIcon>
                  Eliminar ({this.state.selectedRows.filter(Boolean).length})
                </Button>
              )}
              <Button
                className="users-table-refresh-btn"
                onClick={this.getSystemUsers}
                flat
              >
                <FontIcon>refresh</FontIcon>
                Actualizar
              </Button>
            </div>
          </div>

          {this.state.systemUsersLoading && <LinearProgress id='usersProgress' />}

          <div className="users-table-wrapper">
            <DataTable baseId='dynamic-content-desserts' className="users-data-table" onRowToggle={this.handleRowToggle}>
              {this.state.systemUsers && this.state.systemUsers.length > 0 && (
                <React.Fragment>
                  <TableHeader>
                    <TableRow className="users-table-head-row">
                      <TableColumn className="users-th">Usuario</TableColumn>
                      <TableColumn className="users-th">Nombre</TableColumn>
                      <TableColumn className="users-th">Apellido</TableColumn>
                      <TableColumn className="users-th">Email</TableColumn>
                      <TableColumn className="users-th">Rol</TableColumn>
                      <TableColumn className="users-th users-th--actions">Acciones</TableColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {this.state.systemUsers.map((item, i) => (
                      <TableRow key={item.id} className="users-table-body-row" selected={this.state.selectedRows[i] || false}>
                        <TableColumn className="users-td">
                          <span className="users-username">{item.Usuario}</span>
                        </TableColumn>
                        <TableColumn className="users-td">{item.Nombre || '—'}</TableColumn>
                        <TableColumn className="users-td">{item.Apellido || '—'}</TableColumn>
                        <TableColumn className="users-td">
                          <span className="users-email">{item.Email}</span>
                        </TableColumn>
                        <TableColumn className="users-td">
                          <span className={`users-badge users-badge--role-${item.Rol}`}>
                            {item.Rol === 'admin' ? 'Administrador' : item.Rol === 'root' ? 'Root' : 'Usuario'}
                          </span>
                        </TableColumn>
                        <TableColumn className="users-td users-td--actions">
                          <Button
                            className="users-delete-btn"
                            onClick={() => this.deleteSystemUser(item)}
                            icon
                          >
                            <FontIcon>delete</FontIcon>
                          </Button>
                        </TableColumn>
                      </TableRow>
                    ))}
                  </TableBody>
                </React.Fragment>
              )}
            </DataTable>
          </div>

          {this.state.systemUsers && this.state.systemUsers.length === 0 && (
            <div className="users-empty-state">
              <FontIcon className="users-empty-state__icon">person_off</FontIcon>
              <p>No hay usuarios registrados</p>
            </div>
          )}
        </div>
      </DefaultLayout>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.user,
});

export default connect(mapStateToProps)(Users);
